import './SiteFooter.css';

export function SiteFooter() {
    return (
        <div className="d5-bottom-bar">
            <div className="d5-footer-left">© 2026 SteamZip — All generated files purged after 24 hours</div>
            <div className="d5-footer-right">
                <span>No Subscription</span>
                <span>No Account Required</span>
                <span className="red">Launching 2026</span>
            </div>
        </div>
    );
}
